module.exports = __webpack_public_path__ + "img/payBg.3d70baae.png";